module.exports = __webpack_public_path__ + "img/logooffice4.432a8c9d.png";